// @ts-ignore
const envSource = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test' ? process.env : window._env_;
export const getApiBase = () => envSource.REACT_APP_API_BASE || '';